// The width and height of the image generator.
export const generatorSize = 800;

// Eye colours
export const colors = {
  dark: '#353535',
  light: '#fff',
  pink: '#ff8fab',
};

// Eye stroke width
export const eyeStrokeWidth = 10;

// Size of the eye highlight (radius)
export const eyeHightlightSize = 32;

// The size of the nose svg
export const noseSize = 100;

// The size of the ear svg
export const earSize = 296;

// Different cat face emoji characters
export const catEmojis = ['😹', '😻', '🙀', '😿', '😸', '😽', '😺', '😼', '😾'];